import { useIsProduction } from 'hooks/useIsProduction/useIsProduction';
import { useTheme } from 'hooks/useTheme';
import { useTranslations } from 'utils/translations/useTranslations';
import { ReactComponent as HelpIcon } from './icon.svg';
import './Help.scss';

export const Help = () => {
  const isProduction = useIsProduction();
  const { chat: isChatVisible = true } = useTheme();
  const i18n = useTranslations();

  if (!isChatVisible) {
    return null;
  }

  const handleClick = () => {
    if (isProduction) {
      window?.adaEmbed?.toggle();
    }
  };

  return (
    <div className="Help">
      {/* biome-ignore lint/a11y/useValidAnchor: TODO replace it */}
      <a
        onClick={handleClick}
        href="#"
        className="focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-white rounded p-1 text-white"
      >
        <HelpIcon className="Help-logo" />
        {i18n.t('preFooter.help')}
      </a>
    </div>
  );
};
